import $store from "$src/store";
import $axios from "$src/prototypes/axios";

export default function applyRouterGuard(router) {
  let routerErrorCache = "";

  // error cache 초기화
  router.beforeEach((to, from, next) => {
    routerErrorCache = "";
    next();
  });

  // login check
  router.beforeEach(async (to, from, next) => {
    if (routerErrorCache) {
      next();
      return;
    }
    try {
      // 로그인 체크는 항상 하도록함
      const loginRes = await $axios.get("/happycommunity/myInfo", {
        skipCommonErrorHandler: true,
      });
      $store.commit("setUserData", loginRes.data);
    } catch (err) {
      if (err.response.status === 401) routerErrorCache = "loginFail";
      else routerErrorCache = "error";
      console.log(err);
    }
    next();
  });

  // preload
  router.beforeEach(async (to, from, next) => {
    if (routerErrorCache) {
      next();
      return;
    }
    if (!$store.state.groupData) {
      Promise.all([
        $axios.get("/happycommunity/org", { skipCommonErrorHandler: true }),
        $axios.get("/happycommunity/states", { skipCommonErrorHandler: true }),
      ])
        .then((result) => {
          $store.commit("setGroupData", {
            orgList: result[0].data.data,
            stateList: result[1].data,
          });
          next();
        })
        .catch(() => {
          next();
        });
    } else next();
  });

  // 페이지 접근제한
  router.beforeEach((to, from, next) => {
    if (routerErrorCache || !to.meta.permissionInfo) {
      next();
      return;
    }

    const permissionPromiseList = [];
    const accessKey = to.meta.permissionInfo.key;
    permissionPromiseList.push(
      $store.dispatch("loadPermission", to.meta.permissionInfo)
    );
    if (to.meta.permissionInfo.children)
      to.meta.permissionInfo.children.forEach((item) => {
        permissionPromiseList.push($store.dispatch("loadPermission", item));
      });
    Promise.all(permissionPromiseList).then(() => {
      const permissionInfo = $store.state.permissions[accessKey];
      if (!permissionInfo.accessable) routerErrorCache = "unauthenticated";
      next();
    });
  });

  // 마지막에 error state 설정한다. (url 유지하면서 error 페이지를 보여주기 위함)
  router.beforeEach((to, from, next) => {
    $store.commit("setErrorState", routerErrorCache);
    next();
  });
}
